import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _Any: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type FrontEnd = {
  __typename?: 'FrontEnd';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FrontEndModule = {
  __typename?: 'FrontEndModule';
  _id: Scalars['ID']['output'];
  frontEnd: FrontEnd;
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  updateNotificationReadStatus: NotificationReadStatus;
  updateReleaseNoteReadStatus: ReleaseNoteReadStatus;
  updateUser: UpdateUserResponse;
  updateUserPreferences: UserPreferences;
};


export type MutationUpdateNotificationReadStatusArgs = {
  notificationId: Scalars['ID']['input'];
  readStatus: NotificationReadStatusEnum;
};


export type MutationUpdateReleaseNoteReadStatusArgs = {
  productVersionId: Scalars['ID']['input'];
  readStatus: ReleaseNoteReadStatusEnum;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input?: InputMaybe<UserPreferencesInput>;
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['ID']['output'];
  dismissible: Scalars['Boolean']['output'];
  endTS?: Maybe<Scalars['Float']['output']>;
  frontEndModules: Array<FrontEndModule>;
  frontEnds: Array<FrontEnd>;
  level: NotificationLevel;
  message: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  openReleaseNotes: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  startTS?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationLevel {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type NotificationReadStatus = {
  __typename?: 'NotificationReadStatus';
  notificationId: Scalars['ID']['output'];
  readStatus: NotificationReadStatusEnum;
};

export enum NotificationReadStatusEnum {
  Deleted = 'DELETED',
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum PrivacyConsentEnum {
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT'
}

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  frontEndModules: Array<FrontEndModule>;
  frontEnds: Array<FrontEnd>;
  getNotificationReadStatus: Array<NotificationReadStatus>;
  getReleaseNoteReadStatus: Array<ReleaseNoteReadStatus>;
  notifications: Array<Notification>;
  releaseNotes: Array<ReleaseNote>;
  userPreferences: UserPreferences;
};


export type QueryFrontEndModulesArgs = {
  frontEndName: Scalars['String']['input'];
};


export type QueryGetNotificationReadStatusArgs = {
  readStatus: NotificationReadStatusEnum;
};


export type QueryGetReleaseNoteReadStatusArgs = {
  readStatus: ReleaseNoteReadStatusEnum;
};


export type QueryNotificationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  frontEndModuleNames?: InputMaybe<Array<Scalars['String']['input']>>;
  frontEndName: Scalars['String']['input'];
  portfolio_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryReleaseNotesArgs = {
  frontEndName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ReleaseNote = {
  __typename?: 'ReleaseNote';
  _id: Scalars['ID']['output'];
  frontEnd: FrontEnd;
  highlights: Array<ReleaseNoteHighlight>;
  knowledgeCenterUrl?: Maybe<Scalars['String']['output']>;
  releaseDateTS?: Maybe<Scalars['Float']['output']>;
  tags: Array<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ReleaseNoteHighlight = {
  __typename?: 'ReleaseNoteHighlight';
  description?: Maybe<Scalars['String']['output']>;
  highlightUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ReleaseNoteReadStatus = {
  __typename?: 'ReleaseNoteReadStatus';
  productVersionId: Scalars['ID']['output'];
  readStatus: ReleaseNoteReadStatusEnum;
};

export enum ReleaseNoteReadStatusEnum {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum ThemeEnum {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type UpdateUserInput = {
  attributes?: InputMaybe<UserAttributesInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  success: Scalars['Boolean']['output'];
};

export type UserAttributesInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  customDefaultModuleConfig?: Maybe<Scalars['String']['output']>;
  customDefaultModuleEnergyLog?: Maybe<Scalars['String']['output']>;
  customDefaultModuleSolar?: Maybe<Scalars['String']['output']>;
  customDefaultModuleStorage?: Maybe<Scalars['String']['output']>;
  customDefaultModuleWind?: Maybe<Scalars['String']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  decimalFormat?: Maybe<Scalars['String']['output']>;
  defaultPortfolioSolar?: Maybe<Scalars['String']['output']>;
  defaultPortfolioWind?: Maybe<Scalars['String']['output']>;
  emailsNotificationsConsent?: Maybe<Scalars['Boolean']['output']>;
  hourFormat?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  latestPrivacyVersion?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'thousandFormat' and 'decimalFormat' instead */
  numberFormat?: Maybe<Scalars['String']['output']>;
  portfolioTimezone?: Maybe<Scalars['String']['output']>;
  portfolioTimezoneWind?: Maybe<Scalars['String']['output']>;
  privacyConsent?: Maybe<PrivacyConsentEnum>;
  sessionTimeout?: Maybe<Scalars['Boolean']['output']>;
  siteTimezone?: Maybe<Scalars['String']['output']>;
  siteTimezoneWind?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<ThemeEnum>;
  thousandFormat?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userTimezone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'userTimezone' instead */
  userTimezoneWind?: Maybe<Scalars['String']['output']>;
};

export type UserPreferencesInput = {
  customDefaultModuleConfig?: InputMaybe<Scalars['String']['input']>;
  customDefaultModuleEnergyLog?: InputMaybe<Scalars['String']['input']>;
  customDefaultModuleSolar?: InputMaybe<Scalars['String']['input']>;
  customDefaultModuleStorage?: InputMaybe<Scalars['String']['input']>;
  customDefaultModuleWind?: InputMaybe<Scalars['String']['input']>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  decimalFormat?: InputMaybe<Scalars['String']['input']>;
  defaultPortfolioSolar?: InputMaybe<Scalars['String']['input']>;
  defaultPortfolioWind?: InputMaybe<Scalars['String']['input']>;
  emailsNotificationsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hourFormat?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  latestPrivacyVersion?: InputMaybe<Scalars['String']['input']>;
  numberFormat?: InputMaybe<Scalars['String']['input']>;
  portfolioTimezone?: InputMaybe<Scalars['String']['input']>;
  portfolioTimezoneWind?: InputMaybe<Scalars['String']['input']>;
  privacyConsent?: InputMaybe<PrivacyConsentEnum>;
  sessionTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  siteTimezone?: InputMaybe<Scalars['String']['input']>;
  siteTimezoneWind?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<ThemeEnum>;
  thousandFormat?: InputMaybe<Scalars['String']['input']>;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type GetNotificationsQueryVariables = Exact<{
  frontEndName: Scalars['String']['input'];
  frontEndModuleNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', _id: string, dismissible: boolean, startTS?: number | null, endTS?: number | null, level: NotificationLevel, message: string, priority: number, url?: string | null, openReleaseNotes: boolean, notificationType: string }> };

export type GetReleaseNotesQueryVariables = Exact<{
  frontEndName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReleaseNotesQuery = { __typename?: 'Query', releaseNotes: Array<{ __typename?: 'ReleaseNote', _id: string, version?: string | null, releaseDateTS?: number | null, knowledgeCenterUrl?: string | null, highlights: Array<{ __typename?: 'ReleaseNoteHighlight', title: string, description?: string | null, tags: Array<string>, imageUrl?: string | null, highlightUrl?: string | null }> }> };

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesQuery = { __typename?: 'Query', userPreferences: { __typename?: 'UserPreferences', userId: string, language?: string | null, dateFormat?: string | null, hourFormat?: string | null, theme?: ThemeEnum | null, sessionTimeout?: boolean | null, customDefaultModuleWind?: string | null, portfolioTimezoneWind?: string | null, siteTimezoneWind?: string | null, userTimezone?: string | null, thousandFormat?: string | null, decimalFormat?: string | null, privacyConsent?: PrivacyConsentEnum | null, emailsNotificationsConsent?: boolean | null } };

export type UpdateUserPreferencesMutationVariables = Exact<{
  userPreferences: UserPreferencesInput;
}>;


export type UpdateUserPreferencesMutation = { __typename?: 'Mutation', updateUserPreferences: { __typename?: 'UserPreferences', customDefaultModuleWind?: string | null, sessionTimeout?: boolean | null, userId: string, language?: string | null, dateFormat?: string | null, hourFormat?: string | null, theme?: ThemeEnum | null, portfolioTimezoneWind?: string | null, siteTimezoneWind?: string | null, userTimezone?: string | null, thousandFormat?: string | null, decimalFormat?: string | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserResponse', success: boolean } };

export const GetNotificationsDocument = gql`
    query getNotifications($frontEndName: String!, $frontEndModuleNames: [String!], $portfolioIds: [ID!]) {
  notifications(
    frontEndName: $frontEndName
    frontEndModuleNames: $frontEndModuleNames
    portfolio_ids: $portfolioIds
    active: true
  ) {
    _id
    dismissible
    startTS
    endTS
    level
    message
    priority
    url
    openReleaseNotes
    notificationType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsGQL extends Apollo.Query<GetNotificationsQuery, GetNotificationsQueryVariables> {
    document = GetNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReleaseNotesDocument = gql`
    query getReleaseNotes($frontEndName: String!, $limit: Int = 5) {
  releaseNotes(frontEndName: $frontEndName, limit: $limit) {
    _id
    version
    releaseDateTS
    knowledgeCenterUrl
    highlights {
      title
      description
      tags
      imageUrl
      highlightUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReleaseNotesGQL extends Apollo.Query<GetReleaseNotesQuery, GetReleaseNotesQueryVariables> {
    document = GetReleaseNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserPreferencesDocument = gql`
    query getUserPreferences {
  userPreferences {
    userId
    language
    dateFormat
    hourFormat
    theme
    sessionTimeout
    customDefaultModuleWind
    portfolioTimezoneWind
    siteTimezoneWind
    userTimezone
    thousandFormat
    decimalFormat
    privacyConsent
    emailsNotificationsConsent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserPreferencesGQL extends Apollo.Query<GetUserPreferencesQuery, GetUserPreferencesQueryVariables> {
    document = GetUserPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPreferencesDocument = gql`
    mutation updateUserPreferences($userPreferences: UserPreferencesInput!) {
  updateUserPreferences(input: $userPreferences) {
    customDefaultModuleWind
    sessionTimeout
    userId
    language
    dateFormat
    hourFormat
    theme
    portfolioTimezoneWind
    siteTimezoneWind
    userTimezone
    thousandFormat
    decimalFormat
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPreferencesGQL extends Apollo.Mutation<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables> {
    document = UpdateUserPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }